import React from 'react';
import { usePortfolio } from '../../Context/PortfolioContext';
import './BacktestComponent.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faDollarSign, faSeedling, faBalanceScale } from '@fortawesome/free-solid-svg-icons';
import './ReturnCompare.css';
import * as math from 'mathjs';
function calculateWeightedReturn2(selectedAssets, weights) {
    let weightedReturn = 0;
    for (let i = 0; i < selectedAssets.length; i++) {
      const assetReturn = selectedAssets[i].return; // Assuming 'return' is a property containing the asset's return
      const weight = weights[i];
      weightedReturn += assetReturn * weight;
    }
    return weightedReturn;
  }

const calculateWeightedYearlyReturns = (selectedAssets, weights, initialInvestment, targetYears) => {
    let totalReturns = {};
    targetYears.forEach(year => {
      totalReturns[year] = 0; // Initialize return for each year
      selectedAssets.forEach((asset, index) => {
        const weight = weights[index];
        const assetInvestment = weight * initialInvestment;
        const startPrice = asset.yearly_prices[year - 1];
        const endPrice = asset.yearly_prices[year];
        if (startPrice && endPrice) {
          const assetReturn = (endPrice - startPrice) / startPrice;
          totalReturns[year] += assetReturn * assetInvestment; // Accumulate weighted return
        }
      });
      totalReturns[year] = (totalReturns[year] / initialInvestment) * 100; // Convert to percentage
    });
    return totalReturns;
  };

  

  
const calculateWeightedYearlyProfits = (selectedAssets, weights, initialInvestment, targetYears) => {
    let yearlyProfits = {};
    targetYears.forEach(year => {
      yearlyProfits[year] = 0; // Initialize profit for each year
      selectedAssets.forEach((asset, index) => {
        const weight = weights[index];
        const assetInvestment = weight * initialInvestment;
        const startPrice = asset.yearly_prices[year - 1];
        const endPrice = asset.yearly_prices[year];
        if (startPrice && endPrice) {
          const assetReturn = (endPrice - startPrice) / startPrice;
          yearlyProfits[year] += assetReturn * assetInvestment; // Accumulate weighted profit
        }
      });
      // No conversion to percentage needed, as we are calculating profit in THB
    });
    return yearlyProfits;
  };
  
const BacktestedReturnsComponent = ({ selectedAssets, optimizationResults }) => {
  const weights = optimizationResults?.optimizedWeights || [];
  const money = optimizationResults?.wealth || 1000000; // Default wealth
  const targetYears = [2020, 2021, 2022, 2023];

  const totalReturns = calculateWeightedYearlyReturns(selectedAssets, weights, money, targetYears);
  const yearlyProfits = calculateWeightedYearlyProfits(selectedAssets, weights, money, targetYears);
  const profitTHB = calculateWeightedReturn2(selectedAssets, weights)*money;
  const getReturnClass = (yearlyReturn) => {
    if (yearlyReturn > 2) return 'metric-positive';
    if (yearlyReturn < -2) return 'metric-negative';
    return 'metric-neutral';
  };
  // Convert the object values to an array and calculate the mean
    const profitValues = Object.values(yearlyProfits);
    const meanYearlyProfit = profitValues.reduce((acc, curr) => acc + curr, 0) / profitValues.length;

  const percentDifference = ((meanYearlyProfit - profitTHB) / profitTHB) * 100;
  let color;
  if (percentDifference > 10) { // If backtest profit is much higher
      color = '#00ff00';
  } else if (percentDifference < -10) { // If backtest profit is much lower
      color = '#ff00';
  } else { // If about the same
      color = 'ffff00';
  }

  return (
    <>
    <div className="backtested-returns-grid">
        {targetYears.map(year => (
            <div key={year} className="backtested-return">
            <h3>Year: {year}</h3>
            <div className={`metric ${getReturnClass(totalReturns[year])}`}>
                <FontAwesomeIcon icon={faChartLine} />
                <span>Average Return: {totalReturns[year]?.toFixed(2)}%</span>
            </div>
            <div className={`metric ${getReturnClass(totalReturns[year])}`}>
                <FontAwesomeIcon icon={faDollarSign} />
                <span>Profit in THB: ฿{yearlyProfits[year]?.toFixed(2)}</span>
            </div>
            </div>
        ))}
    </div>
    <div className="return-comparison">
            <h2>Return Comparison</h2>
            <div className="comparison-details">
                <div className="backtested-returns">
                    <h3>Average Cumulative Backtested Return</h3>
                    <p style={{ color }}>Profit in THB: ฿ {meanYearlyProfit.toFixed(2)}</p>
                </div>
                <div className="predicted-yearly-return">
                    <h3>Predicted Yearly Return</h3>
                    <p>Profit in THB: ฿ {profitTHB.toFixed(2)}</p>
                </div>
                <div className="percent-difference">
                    <h3>Percent Difference</h3>
                    <p style={{ color }}>{percentDifference.toFixed(2)}%</p>
                </div>
            </div>
    </div>
    </>
  );
};

export default BacktestedReturnsComponent;
